<template>
  <div class="page-content">
    <div class="page flex-col">
      <div class="group_5 flex-col">
        <span class="text_36">专业会展主办承办公司</span>
        <span class="line-h"></span>
        <span class="text_37">整体策划</span>
        <div class="text-wrapper_6 flex-row justify-between">
          <span class="text_38">展会主题</span>
          <span class="text_39">/</span>
          <span class="text_40">论坛议题</span>
          <span class="text_41">/</span>
          <span class="text_42">配套活动</span>
          <span class="text_43">/</span>
          <span class="text_44">目标客群</span>
        </div>
        <span class="text_45">场馆规划</span>
        <div class="text-wrapper_7 flex-row justify-between">
          <span class="text_46">空间规划</span>
          <span class="text_47">/</span>
          <span class="text_48">会议区规划</span>
          <span class="text_49">/</span>
          <span class="text_50">展览规划</span>
          <span class="text_51">/</span>
          <span class="text_52">公共设施</span>
          <span class="text_53">/</span>
          <span class="text_54">功能区规划</span>
        </div>
        <span class="text_55">视觉设计</span>
        <div class="text-wrapper_8 flex-row justify-between">
          <span class="text_56">VI&nbsp;系统</span>
          <span class="text_57">/</span>
          <span class="text_58">主视觉</span>
          <span class="text_59">/</span>
          <span class="text_60">主舞台</span>
          <span class="text_61">/</span>
          <span class="text_62">衍生应用</span>
          <span class="text_63">/</span>
          <span class="text_64">氛围营造</span>
          <span class="text_65">/</span>
          <span class="text_66">展台</span>
        </div>
        <span class="text_67">招商招展</span>
        <div class="text-wrapper_9 flex-row justify-between">
          <span class="text_68">展商及赞助商招募</span>
          <span class="text_69">/</span>
          <span class="text_70">合同签约</span>
          <span class="text_71">/</span>
          <span class="text_72">广告售卖</span>
          <span class="text_73">/</span>
          <span class="text_74">衍生应用</span>
          <span class="text_75">/</span>
          <span class="text_76">特许经营</span>
        </div>
        <span class="text_77">主场服务</span>
        <div class="text-wrapper_10 flex-row justify-between">
          <span class="text_78">主场搭建</span>
          <span class="text_79">/</span>
          <span class="text_80">主场运输</span>
          <span class="text_81">/</span>
          <span class="text_82">展位</span>
          <span class="text_83">/</span>
          <span class="text_84">会议室</span>
          <span class="text_85">/</span>
          <span class="text_86">功能区搭建</span>
          <span class="text_87">/</span>
          <span class="text_88">物料制作</span>
        </div>
        <span class="text_89">安全管理</span>
        <div class="text-wrapper_11 flex-row">
          <span class="text_90">安保交通</span>
          <span class="text_91">/</span>
          <span class="text_92">应急医疗</span>
          <span class="text_93">/</span>
          <span class="text_94">食品安全</span>
          <span class="text_95">/</span>
          <span class="text_96">网络安全</span>
          <span class="text_97">/</span>
          <span class="text_98">展后报告</span>
          <span class="text_99">/</span>
          <span class="text_100">ESG报告</span>
        </div>
        <span class="text_101">数字化服务</span>
        <div class="text-wrapper_12 flex-row justify-between">
          <span class="text_102">系统搭建</span>
          <span class="text_103">/</span>
          <span class="text_104">功能开发</span>
          <span class="text_105">/</span>
          <span class="text_106">数据搜集与分析</span>
          <span class="text_107">/</span>
          <span class="text_108">票证登录</span>
          <span class="text_109">/</span>
          <span class="text_110">网站</span>
          <span class="text_111">/</span>
          <span class="text_112">小程序</span>
        </div>
        <span class="text_113">会务服务</span>
        <div class="text-wrapper_13 flex-row justify-between">
          <span class="text_114">财务管理</span>
          <span class="text_115">/</span>
          <span class="text_116">供应商管理</span>
          <span class="text_117">/</span>
          <span class="text_118">论文征集与评审</span>
          <span class="text_119">/</span>
          <span class="text_120">视频直播</span>
          <span class="text_121">/</span>
          <span class="text_122">剪辑</span>
          <span class="text_123">/</span>
          <span class="text_124">制作</span>
          <span class="text_125">/</span>
          <span class="text_126">摄影摄像</span>
          <span class="text_127">/</span>
        </div>
        <div class="text-wrapper_14 flex-row justify-between">
          <span class="text_128">速记</span>
          <span class="text_129">/</span>
          <div class="text_130" @click="openRouter('下游','会展翻译')">同声传译</div>
          <span class="text_131">/</span>
          <span class="text_132">会议文件编制撰写</span>
          <span class="text_133">/</span>
          <span class="text_134">志愿者服务</span>
        </div>
        <span class="text_135">嘉宾接待</span>
        <div class="text-wrapper_15 flex-row justify-between">
          <span class="text_136">要客路线规划</span>
          <span class="text_137">/</span>
          <span class="text_138">抵离迎送</span>
          <span class="text_139">/</span>
          <span class="text_140">接待讲解</span>
          <span class="text_141">/</span>
          <span class="text_142">数字化管理系统</span>
          <span class="text_143">/</span>
          <span class="text_144">贵宾室管理</span>
        </div>
        <span class="text_145">宣传推广</span>
        <div class="text-wrapper_16 flex-row justify-between">
          <span class="text_146">品牌商业化方案</span>
          <span class="text_147">/</span>
          <span class="text_148">协助申报市政道旗</span>
          <span class="text_149">/</span>
          <span class="text_150">奥园区灯光氛围</span>
          <span class="text_151">/</span>
          <span class="text_152">媒体邀约与管理</span>
          <span class="text_153">/</span>
          <span class="text_154">专访安排</span>
        </div>
        <div class="text-wrapper_17 flex-row justify-between">
          <span class="text_155">/</span>
          <span class="text_156">稿件撰写</span>
        </div>
      </div>
      <div class="group_2 flex-col">
        <span class="text_1">文旅及商务考察业务</span>
        <span class="line-h"></span>
        <span class="text_2">商务服务</span>
        <div class="text-wrapper_1 flex-row justify-between">
          <span class="text_3">城市考察</span>
          <span class="text_4">/</span>
          <span class="text_5">技术考察</span>
          <span class="text_6">/</span>
          <span class="text_7">行业调研</span>
        </div>
        <span class="text_8">休闲服务</span>
        <div class="text-wrapper_2 flex-row justify-between">
          <span class="text_9">定制文旅活动策划执行</span>
          <span class="text_10">/</span>
          <span class="text_11">工业旅游活动策划执行</span>
          <span class="text_12">/</span>
          <span class="text_13">中轴线双层巴士交通接待管理</span>
        </div>
        <div class="text-wrapper_3 flex-row justify-between">
          <span class="text_14">文化空间（与周边14家场馆形成联动）活动策划执行</span>
          <span class="text_15">/</span>
        </div>
      </div>
      <div class="group_4 flex-col">
        <div class="block_1 flex-col">
          <span class="text_157">会展附加业务</span>
          <span class="line-h"></span>
          <span class="text_158">涉外邀请</span>
          <div class="text-wrapper_18 flex-row justify-between">
            <span class="text_159">涉外邀请函</span>
            <span class="text_160">/</span>
            <span class="text_161">境外嘉宾邀请</span>
            <span class="text_162">/</span>
            <span class="text_163">境外专业观众组织</span>
            <span class="text_164">/</span>
            <span class="text_165">境外供需配对活动策划</span>
          </div>
          <span class="text_166">报批报备</span>
          <div class="text-wrapper_19 flex-row justify-between">
            <span class="text_167">会展项目备案</span>
            <span class="text_168">/</span>
            <span class="text_169">公安报批</span>
            <span class="text_170">/</span>
            <span class="text_171">消防报批</span>
          </div>
          <span class="text_172">会务礼品</span>
          <div class="text-wrapper_20 flex-row justify-between">
            <span class="text_173">文创衍生品设计</span>
            <span class="text_174">/</span>
            <span class="text_175">制作</span>
            <span class="text_176">/</span>
            <span class="text_177">销售</span>
            <span class="text_178">/</span>
            <span class="text_179">特许经营</span>
            <span class="text_180">/</span>
            <span class="text_181">伴手礼定制</span>
          </div>
        </div>
      </div>
      <div class="group_4 flex-col">
        <div class="block_2 flex-col">
          <span class="text_182">展演业务</span>
          <span class="line-h"></span>
          <span class="text_183">活动策划</span>
          <div class="text-wrapper_21 flex-row justify-between">
            <span class="text_184">活动主题</span>
            <span class="text_185">/</span>
            <span class="text_186">流程设计</span>
            <span class="text_187">/</span>
            <span class="text_188">节目亮点</span>
            <span class="text_189">/</span>
            <span class="text_190">主创邀清</span>
          </div>
          <span class="text_191">组织执行</span>
          <div class="text-wrapper_22 flex-row justify-between">
            <span class="text_192">场地踏勘</span>
            <span class="text_193">/</span>
            <span class="text_194">舞台搭建</span>
            <span class="text_195">/</span>
              <span class="text_196" @click="openRouter('下游','灯光音响')">灯光</span>
              <span class="text_197">/</span>
              <span class="text_198" @click="openRouter('下游','灯光音响')">音响</span>
            <span class="text_199">/</span>
            <span class="text_200">节目创作</span>
            <span class="text_201">/</span>
            <span class="text_202">彩排演练</span>
            <span class="text_203">/</span>
            <span class="text_204">节目优化</span>
            <span class="text_205">/</span>
          </div>
          <div class="text-wrapper_23 flex-row justify-between">
            <span class="text_206">赛务管理</span>
            <span class="text_207">/</span>
            <span class="text_208">宣传营销</span>
            <span class="text_209">/</span>
            <span class="text_210">周边文创制作</span>
            <span class="text_211">/</span>
            <span class="text_212">销售</span>
            <span class="text_213">/</span>
            <span class="text_214">销售供应商管理</span>
          </div>
          <span class="text_215">非遗展演</span>
          <div class="text-wrapper_24 flex-row justify-between">
            <span class="text_216">非速项目招募</span>
            <span class="text_217">/</span>
            <span class="text_218">策划</span>
            <span class="text_219">/</span>
            <span class="text_220">执行</span>
          </div>
        </div>
      </div>
      <div class="group_4 flex-col">
        <div class="block_3 flex-col">
          <span class="text_221">酒店业务</span>
          <span class="line-h"></span>
          <div class="text-wrapper_25 flex-row justify-between">
            <span class="text_222">酒店服务预定</span>
            <span class="text_223">/</span>
            <span class="text_224">入住</span>
            <span class="text_225">/</span>
            <span class="text_226">接送机</span>
            <span class="text_227">/</span>
            <span class="text_228">客服服务</span>
            <span class="text_229">/</span>
            <span class="text_230">网络服务</span>
          </div>
        </div>
      </div>
      <div class="group_4 flex-col">
        <div class="block_4 flex-col">
          <span class="text_16">餐饮业务</span>
          <span class="line-h"></span>
          <span class="text_17">普通服务</span>
          <div class="text-wrapper_4 flex-row justify-between">
            <span class="text_18">中西式正餐（零点或套餐）</span>
            <span class="text_19">/</span>
            <span class="text_20">宴会服务（中式或西式）</span>
            <span class="text_21">/</span>
            <span class="text_22">自助餐</span>
            <span class="text_23">/</span>
            <span class="text_24">会议餐饮</span>
            <span class="text_25">/</span>
          </div>
          <span class="text_26">酒吧服务</span>
          <span class="text_27">特殊服务</span>
          <div class="text-wrapper_5 flex-row justify-between">
            <span class="text_28">客房送餐(酒店专属)</span>
            <span class="text_29">/</span>
            <span class="text_30">定制化外卖（外派团队执行）</span>
            <span class="text_31">/</span>
          </div>
          <span class="text_32">主题庆祝活动（结合餐饮与娱乐）</span>
          <span class="text_33">商务宴请</span>
          <span class="text_34">10-1000人高端商务宴请定制服务</span>
          <span class="text_35">大型宴会</span>
          <span class="paragraph_1">
              1000人以上宴会场地、策划、餐饮服务
              <br />
            </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ServiceHome",
  data() {
    return {
      constants: {}
    };
  },
  methods: {
    openRouter(level, block){
      const { href } = this.$router.resolve({
        path: '/service/list',
        query:{level: level, tag:block, searchVisi: true}
      });
      window.open(href, '_self', 'noopener');
    }
  }
};
</script>
<style scoped lang="css" src="./service/index.css" />
<style scoped lang="css" src="./service/common.css" />
<style scoped>
.page-content{
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  flex-wrap: nowrap;
}
</style>
